module.exports = __webpack_public_path__ + "static/img/10.0c91eeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/10.png
// module id = zs0D
// module chunks = 0